import React from 'react';
import { Music, Heart, Sparkles } from 'lucide-react';

const BrandIdentity = () => {
  return (
    <section className="relative py-20 bg-gradient-to-b from-[#0a0a0a] to-[#1a1a1a]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="inline-flex items-center space-x-2 bg-[#D4AF37]/10 border border-[#D4AF37]/30 rounded-full px-6 py-2 mb-6">
            <Music className="w-5 h-5 text-[#D4AF37]" />
            <span className="text-[#D4AF37] font-bold text-sm">WHO WE ARE</span>
          </div>
          
          <h2 className="text-4xl sm:text-5xl md:text-6xl font-bold text-white mb-6" style={{ fontFamily: '"Bebas Neue", sans-serif' }}>
            A RECORD LABEL &
            <span className="block text-transparent bg-clip-text bg-gradient-to-r from-[#D4AF37] to-[#FFD700]">
              CREATIVE HEALING PLATFORM
            </span>
          </h2>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="bg-gradient-to-br from-[#1a1a1a] to-[#0f0f0f] border border-[#D4AF37]/20 rounded-2xl p-8 md:p-12">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
              <div className="text-center">
                <div className="w-16 h-16 bg-gradient-to-br from-[#D4AF37] to-[#FFD700] rounded-full flex items-center justify-center mx-auto mb-4">
                  <Music className="w-8 h-8 text-[#0a0a0a]" />
                </div>
                <h3 className="text-xl font-bold text-[#D4AF37] mb-2" style={{ fontFamily: '"Bebas Neue", sans-serif' }}>
                  GOSPEL & HIP-HOP
                </h3>
                <p className="text-gray-400 text-sm">Trauma-informed music that heals</p>
              </div>

              <div className="text-center">
                <div className="w-16 h-16 bg-gradient-to-br from-[#D4AF37] to-[#FFD700] rounded-full flex items-center justify-center mx-auto mb-4">
                  <Heart className="w-8 h-8 text-[#0a0a0a]" />
                </div>
                <h3 className="text-xl font-bold text-[#D4AF37] mb-2" style={{ fontFamily: '"Bebas Neue", sans-serif' }}>
                  HEALING CENTERED
                </h3>
                <p className="text-gray-400 text-sm">Emotional & spiritual transformation</p>
              </div>

              <div className="text-center">
                <div className="w-16 h-16 bg-gradient-to-br from-[#D4AF37] to-[#FFD700] rounded-full flex items-center justify-center mx-auto mb-4">
                  <Sparkles className="w-8 h-8 text-[#0a0a0a]" />
                </div>
                <h3 className="text-xl font-bold text-[#D4AF37] mb-2" style={{ fontFamily: '"Bebas Neue", sans-serif' }}>
                  COMMUNITY DRIVEN
                </h3>
                <p className="text-gray-400 text-sm">Storytelling & expression</p>
              </div>
            </div>

            <div className="prose prose-invert max-w-none">
              <p className="text-xl text-gray-300 leading-relaxed mb-6">
                <span className="text-[#D4AF37] font-bold">40 Songs and a Mic</span> is a gospel and trauma-informed hip-hop record label dedicated to healing, storytelling, and transformation through music.
              </p>
              
              <p className="text-lg text-gray-400 leading-relaxed">
                Our mission is to use music, testimony, and community expression to support emotional healing, spiritual growth, and trauma recovery. We believe that every story deserves to be heard, every voice deserves to be amplified, and every person deserves a path to healing.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BrandIdentity;
